import point from "../point";
import line from "../line";
import config from "../../../store/sqftConfig";

const wideAngle = function() {
  let points;
  if(config.measureUnit === "Metric" ) {
    points = [
      new point(-13.62, -10, "lefttop"),
      new point(134, -10, "righttop"),
      new point(134, 13.62, "rightbottom"),
      new point(10, 13.62, "rightbottom", true),
      new point(10, 114, "rightbottom"),
      new point(-13.62, 114, "leftbottom")
    ];
  } else {
    points = [
      new point(-16, -10, "lefttop"),
      new point(134, -10, "righttop"),
      new point(134, 16, "rightbottom"),
      new point(10, 16, "rightbottom", true),
      new point(10, 114, "rightbottom"),
      new point(-16, 114, "leftbottom")
    ];
  }

  let lines = [
    new line(points[0], points[1]),
    new line(points[1], points[2]),
    new line(points[2], points[3]),
    new line(points[3], points[4]),
    new line(points[4], points[5]),
    new line(points[5], points[0])
  ];

  return lines;
};

export default wideAngle
